export default __webpack_public_path__ + "static/media/SL_Mathematics_AI.0f1fa5fc.svg";